export enum TokenPaginationEvent {
  CHANGE_LIMIT = 'changeLimit',
  NEXT_PAGE = 'nextPage',
  PREV_PAGE = 'prevPage',
  UPDATE_PAGINATION = 'updatePagination',
  RESET_PAGINATION = 'resetPagination',
}
